import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  BackgroundImage,
} from './Styles';
import Header from '../../../Common/Header';
import Logo from '../../../Common/Logo';
import { isMobile, lang } from '../../../../../lib/utils/utils';
import PingFangMediumText from '../../../../../components/Text/PingFangMediumText';
import SquadSemiBoldItalicText from '../../../../../components/Text/SquadSemiBoldItalicText';
import ColumnCenter from '../../../../../components/Layout/ColumnCenter';
import SquadRegularText from '../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../components/Text/PingFangRegularText';
import { AppleStore, GoogleStore } from '../../../../../assets/svg-image/app-store';
import ProblemReportModal from '../../../Common/ProblemReportModal';
import OnlineDeliveryWarningModal from '../../../Common/OnlineDeliveryWarningModal';
import Column from '../../../../../components/Layout/Column';

const DownloadApp: FC<Props> = ({
  setTargetPage,
  isEnglish,
  setIsEnglish,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      {
        showModal && (
          <OnlineDeliveryWarningModal
            onClose={() => setShowModal(false)}
          />
        )
      }
      <Column style={{ alignItems: 'center' }}>
        <div style={{ width: isMobile() ? undefined : 400 }}>
          {/* 头部 */}
          <Header
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            style={{ marginTop: '50px' }}
            setTargetPage={setTargetPage}
            supportIsOnlyCall={true}
          />

          {/* Logo */}
          <div style={{ marginTop: 30 }}>
            <Logo setTargetPage={setTargetPage} backToPage={'home'} showSubtitle={false} />
          </div>

          <SquadSemiBoldItalicText fontSize={28} textAlign={'center'} marginTop={47}>
            Foodifox Drop-Off
          </SquadSemiBoldItalicText>

          <ColumnCenter style={{ marginTop: 15 }}>
            {
              lang(
                <SquadSemiBoldItalicText textAlign={'center'} width={270} lineHeight={20}>
                  Deliver faster, easier, and more securely with our Foodifox Drop-Off app.
                </SquadSemiBoldItalicText>,
                <PingFangMediumText textAlign={'center'} width={285} lineHeight={22}>
                  使用我们的Foodifox Drop-Off应用程序，让配送更快捷、更轻松、更安全。
                </PingFangMediumText>
              )
            }
            {
              lang(
                <SquadRegularText textAlign={'center'} width={270} lineHeight={20}>
                  As a delivery partner, you’ll earn rewards for simply completing your deliveries!
                </SquadRegularText>,
                <PingFangRegularText textAlign={'center'} width={285} lineHeight={22}>
                  作为一名配送合作伙伴，你只需完成配送任务就能获得奖励！立即下载体验，开启高效配送新篇章！
                </PingFangRegularText>
              )
            }

            <img src={AppleStore} style={{ backgroundColor: '#222222', width: 172, borderRadius: 5, marginTop: 25 }} onClick={() => { location.href = 'https://apps.apple.com/us/app/foodifox-drop-off/id6479691366?%24web_only=true&_branch_match_id=1433374755004751640&utm_medium=marketing&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT8vPT8lMy6%2FQSywo0MvJzMvWT9U3SM4rdjc29QzxSLKvK0pNSy0qysxLj08qyi8vTi2ydc4oys9NBQDRSSl4QQAAAA%3D%3D'; }} />
            <img src={GoogleStore} style={{ backgroundColor: '#222222', width: 172, borderRadius: 5, marginTop: 19 }} onClick={() => { location.href = 'https://play.google.com/store/apps/details?id=com.foodifox3pd.driver&utm_medium=marketing&$web_only=true&_branch_match_id=1448837130037738190&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT8vPT8lMy6/QSywo0MvJzMvWT9U3SM4rdjc29QzxSLKvK0pNSy0qysxLj08qyi8vTi2ydc4oys9NBQDRSSl4QQAAAA%3D%3D&pli=1'; }} />
          </ColumnCenter>
        </div>
      </Column>
    </>
  );
};

export interface Props {
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
}

export default DownloadApp;
